import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './multiEngagement.intl.json';

export const useMultiEngagementIntl = () => useIntlModule(messages);
